<div class="position-fixed sticky-top w-100" style="left: 0; right: 0; z-index: 15000;">
  <app-alerting></app-alerting>
</div>
<app-overview [overviewFilters]="filters.overviewFilters" [searchFunction]="searchTermFunction"
              (resultsFound)="renderRecords($event, false)"
              [isEmpty]="isEmpty" [facetNameFormatter]="nameFormatter" [facetsLoading]="facetsLoading" [facets]="facets"
              [otherFacets]="otherFacets"
              (facetFiltersChanged)="facetFiltersChanged($event)" (loadNextPage)="loadNextPage()"
              (filtersCleared)="clearFilters($event)"
              [quickViews]="quickViews"
              [allSelectable]="anyRecordSelectable" [(selectionState)]="allSelectionState"
              [specificFacetFiltersTemplate]="specificFacetFilters"
              [virtualScroll]="true" [itemSize]="65" [virtualData]="data"
              [virtualItemTemplate]="releaseItemTemplate" [virtualTrackBy]="trackByRecord">
  <div class="header-bar d-flex">
    @if (appContext.isAllowedToAddCommercialRelease()) {
      <button (click)="openNewRelease()" class="btn btn-primary text-decoration-none" tabindex="-1">
        <i class="button-icon fa-light fa-plus"></i>
        <span class="ps-2 d-none d-lg-inline">New release</span>
      </button>
    }
    @if (appContext.isCommercialReleaseDeclarant()) {
      <button (click)="uploadCommercialReleases()" class="btn btn-outline-info ms-3 text-decoration-none" type="button">
        <i class="button-icon fa-light fa-upload"></i>
        <span class="ps-2 d-none d-lg-inline">Upload</span>
      </button>
    }
    <div class="sub-text ms-3 align-items-center d-none d-sm-flex">
      <i class="fa fa-fw fa-light fa-xl fa-file-invoice-dollar me-1"></i>
      <app-loading-icon [loading]="facetsLoading">
        <span>{{ releaseCount | numberFormat }}</span>
      </app-loading-icon>
    </div>
  </div>
  <div class="empty-container col-12 h-100 d-flex align-items-center justify-content-center flex-column">
    <img src="/assets/new-portvisit/no-results-icon-cargo-import.svg" alt="No releases found icon" class="mb-2"/>
    <span class="h1 mb-2">No releases found...</span>
    @if (filters.overviewFilters.selectedQuickView !== quickViews[0]) {
      <span class="text-secondary">
        <span>Try going to the </span>
        <span class="link-primary underline-primary cursor-pointer"
              (click)="filters.overviewFilters.selectedQuickView = quickViews[0]; facetFiltersChanged(filters.overviewFilters)">{{ quickViews[0].name }}</span>
        <span> quick view</span>
      </span>
    } @else {
      <span class="text-secondary">Try adjusting your search term</span>
    }
  </div>

  <div class="overview-footer position-relative">
    @if (nrOfSelectedReleases) {
      <div class="row bg-light px-1 px-lg-3 pb-3 gy-3 border-top">
        <div class="col-12 col-md-auto col-lg d-flex align-items-center">
          <span class="sub-text me-2">
            <i class="fa fa-fw fa-light fa-xl fa-file-lines"></i>
          </span>
          <span class="d-inline-flex text-nowrap">{{ nrOfSelectedReleases }} release{{ nrOfSelectedReleases > 1 ? 's' : '' }}</span>
        </div>
        <div class="col ms-auto p-0"></div>
        <div class="col-12 col-sm-6 col-md-auto">
          <app-confirmation-toggle>
            <button class="btn btn-outline-danger me-3" style="min-width: 10rem" type="button">Cancel</button>
            <div class="modal-content">
              <div class="modal-header"><h5 class="modal-title">Send cancel request to terminal</h5></div>
              <div class="modal-body"><p>Are you sure that you want to cancel all accepted releases?</p></div>
              <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelSelected()">
                  Cancel releases
                </button>
              </div>
            </div>
          </app-confirmation-toggle>
          <button class="btn btn-outline-info me-3" style="min-width: 10rem" type="button" (click)="exportSelected()">
            Export
          </button>
          <button class="btn btn-outline-info" style="min-width: 10rem" type="button"
                  (click)="redeclareCommercialReleases()">Change terminal
          </button>
        </div>
      </div>
    }
  </div>
</app-overview>

<ng-template #releaseItemTemplate let-summary>
  <app-commercial-release-overview-item
    [summary]="summary" [term]="searchTerm"
    [selectable]="isSelectable(summary)" [selected]="isRecordSelected(summary)"
    (selectionToggled)="toggleRecordSelection(summary)"></app-commercial-release-overview-item>
</ng-template>

<ng-template #bulkRedeclareBody>
  <p>
    You are about to change the terminal of the commercial releases below (<b>{{ nrOfSelectedReleases }} items</b>).
    <br/>
    Please check if all consignment – container numbers are correct <br/>
    <b>NOTE: Changes are not immediately visible and can take some minutes.</b>
  </p>
  <ul class="row">
    @for (commercialRelease of getSelectedReleases(); track commercialRelease.id) {
      <li class="col-6">
        {{ commercialRelease.releaseData?.consignmentNumber }} – {{ commercialRelease.releaseData?.equipmentNumber }}
      </li>
    }
  </ul>
  <div class="row gy-4">
    <app-form-group label="Terminal">
      <app-select required [(ngModel)]="redeclareData.terminalShortName" [options]="terminals"
                  [formatter]="terminalOrganisationName"></app-select>
    </app-form-group>
  </div>
</ng-template>


<ng-template #specificFacetFilters>
  <div class="col-12">
    <app-facet-date-range [ranges]="ranges" [filterName]="'Last updated'" (ngModelChange)="declarationDateChanged($event)"
                          [(ngModel)]="filters.overviewFilters.filters.timeRange"
                          [removable]="false" [filterDisabled]="!!filters.overviewFilters.term || !!filters.overviewFilters.filters.crn"></app-facet-date-range>
  </div>
  <div class="col-12">
    <app-facet-filter-search-field
      [filterName]="'Call reference number'" [inputFormatter]="utils.visitFormatterExtended" [searchFunction]="findVisits"
      [value]="filters.overviewFilters.filters.crn" dataKey="crn" (valueSelected)="crnFilterChanged($event)"
      [selectedValueFormatter]="crnFilterValueFormatter"></app-facet-filter-search-field>
  </div>
  <div class="col-12">
    <app-facet-filter-search-field
      [filterName]="'Release-to party'" [inputFormatter]="refData.formatReleaseToParty" [searchFunction]="findReleaseToPartiesForFacet"
      [value]="filters.overviewFilters.filters.releaseToParty" dataKey="releaseToPartyPortbaseId" (valueSelected)="releaseToPartyFilterChanged($event)"
      [selectedValueFormatter]="releaseToPartyFilterValueFormatter"></app-facet-filter-search-field>
  </div>
  <div class="col-12">
    <app-facet-filter-search-field
      [filterName]="'Inland operator'" [inputFormatter]="refData.inlandOperatorFormatter" [searchFunction]="findInlandOperatorsForFacet"
      [value]="filters.overviewFilters.filters.inlandOperator" dataKey="inlandOperatorEan" (valueSelected)="inlandOperatorFilterChanged($event)"
      [selectedValueFormatter]="inlandOperatorFilterValueFormatter" [minCharacters]="3"></app-facet-filter-search-field>
  </div>
</ng-template>
